/** Read a price out of a grid input's change event; blank or unparsable input clears the cell. */
export function parsePriceInput(event: Event): number | null {
  const value = (event.target as HTMLInputElement).value;
  if (value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
